import { render, staticRenderFns } from "./DiamondButtons.vue?vue&type=template&id=709ce475&scoped=true&"
import script from "./DiamondButtons.vue?vue&type=script&lang=js&"
export * from "./DiamondButtons.vue?vue&type=script&lang=js&"
import style0 from "./DiamondButtons.vue?vue&type=style&index=0&id=709ce475&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709ce475",
  null
  
)

export default component.exports